import * as DOM from "../services/dom";
import {Component} from "./component";

export class CommentButton extends Component {

    setup() {
        this.elem = this.$el;
        this.paragraphID = this.$opts.paragraphId;
        this.pageId = this.$opts.id;
        this.type = this.$opts.type;
        this.container = this.$refs.container;

        this.elem.addEventListener('click', this.getComments.bind(this));
    }

    getComments()
    {
        let reqData = {
            id: this.pageId,
            paragraphID: this.paragraphID,
            type: this.type,
        };

        // //todo loader
        window.$http.post(`/comments/modal`, reqData).then(resp => {
            let modalConteiner = document.getElementById('comments-modal');
            modalConteiner.innerHTML = resp.data;
            window.$components.init(modalConteiner);

            let modal = document.getElementById("commentsModal");
            modal.style.display = "block";

            var span = document.getElementsByClassName("close")[0];

            DOM.onEvents(span, ['click'], event => {
                modal.style.display = "none";
            });

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }
}
